import React, { Component } from 'react';
import ClCamera from './Camera';
import Notifier from './Notifier';

class CaptureCamera extends Component {
    constructor() {
        super();
        this.state = {
            offline: false,
            uploadedImageUrl: ''
        }
        // { parentCallback, value } = this.props;
    }
    
    handleImageUpload({url}) {
        this.setState({ uploadedImageUrl: url });
        this.props.onImageUpload({postPicture: url});
        this.props.handleTransition({});
        console.log("In CaptureCamera.js", url)
    }
   
    componentDidMount() {
        window.addEventListener('online', () => {
            this.setState({ offline: false });
        });

        window.addEventListener('offline', () => {
            this.setState({ offline: true });
        });
    }

    componentDidUpdate() {
        let offlineStatus = !navigator.onLine;
        if (this.state.offline !== offlineStatus) {
            this.setState({ offline: offlineStatus });
        }
    }
    
    updateParent(value) {
        console.log(value);
        this.props.createPostCallback(value);
    }

    render() {

        // onChange={this.updateParent.bind(this)} inside ClCamera
        return (
            <div>
                <Notifier offline={this.state.offline} style={{marginTop:"100px"}} />
                <ClCamera onImageUpload={this.handleImageUpload.bind(this)}  offline={this.state.offline}></ClCamera>
            </div>
        );
    }
}

export default CaptureCamera;